import styled from 'styled-components';

export const mobileSideOffset = 'calc(50% - 75vw/2 - 23px)';
export const tabletSideOffset = '18%';
export const desktopSideOffset = '28.4%';
export const desktopVerticalOffset = '3rem';
export const mobileVerticalOffset = '3rem';
export const halfContainerSideOffsetDesktop = '6.5%';

export const Section = styled.section`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  background-color: ${({ backgroundColor }) => backgroundColor};
  @media (min-width: 1280px) {
    display: flex;
    flex-direction: row;
    height: ${({ height }) => (height ? `${height}vh` : '90vh')};
    flex-direction: ${({ reversed }) => (reversed ? 'row-reverse' : 'row')};
  }

  @media (min-width: 1280px) and (min-height: 1300px) {
    height: 1235px;
  }

  @media (min-width: 1920px) and (max-height: 899px) {
    min-height: 600px;
  }
  @media (min-width: 1280px) and (max-height: 699px) {
    min-height: 500px;
  }
`;

export const BackgroundOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-repeat: ${({ backgroundImageMobile }) =>
    backgroundImageMobile.backgroundRepeat};
  background-position: ${({ backgroundImageMobile }) =>
    backgroundImageMobile.backgroundPosition || 'center'};
  background-size: ${({ backgroundImageMobile }) =>
    backgroundImageMobile.backgroundSize || 'cover'};
  background-color: ${({ backgroundColor }) => backgroundColor};
  background-image: ${({ backgroundImageMobile }) =>
    `url(${backgroundImageMobile.src})`};
  opacity: ${({ backgroundImageMobile }) =>
    backgroundImageMobile.backgroundOpacity};
  @media (min-width: 1280px) {
    background-repeat: ${({ backgroundImageDesktop }) =>
    backgroundImageDesktop.backgroundRepeat};
    background-position: ${({ backgroundImageDesktop }) =>
    backgroundImageDesktop.backgroundPosition || 'center'};
    background-size: ${({ backgroundImageDesktop }) =>
    backgroundImageDesktop.backgroundSize || 'cover'};
    background-color: ${({ backgroundColor }) => backgroundColor};
    background-image: ${({ backgroundImageDesktop }) =>
    `url(${backgroundImageDesktop.src})`};
    opacity: ${({ backgroundImageDesktop }) =>
    backgroundImageDesktop.backgroundOpacity};
  }
`;

export const BackgroundOverlayNarrow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-repeat: ${({ backgroundImageMobile }) =>
    backgroundImageMobile.backgroundRepeat};
  background-position: ${({ backgroundImageMobile }) =>
    backgroundImageMobile.backgroundPosition || 'center'};
  background-size: ${({ backgroundImageMobile }) =>
    backgroundImageMobile.backgroundSize || 'cover'};
  background-color: ${({ backgroundColor }) => backgroundColor};
  background-image: ${({ backgroundImageMobile }) =>
    `url(${backgroundImageMobile.src})`};
  opacity: ${({ backgroundImageMobile }) =>
    backgroundImageMobile.backgroundOpacity};
  @media (min-width: 1024px) {
    background-repeat: ${({ backgroundImageDesktop }) =>
    backgroundImageDesktop.backgroundRepeat};
    background-position: ${({ backgroundImageDesktop }) =>
    backgroundImageDesktop.backgroundPosition || 'center'};
    background-size: ${({ backgroundImageDesktop }) =>
    backgroundImageDesktop.backgroundSize || 'cover'};
    background-color: ${({ backgroundColor }) => backgroundColor};
    background-image: ${({ backgroundImageDesktop }) =>
    `url(${backgroundImageDesktop.src})`};
    opacity: ${({ backgroundImageDesktop }) =>
    backgroundImageDesktop.backgroundOpacity};
  }
`;

export const CenterContainer = styled.div`
  margin: ${mobileVerticalOffset} ${mobileSideOffset};
  overflow: hidden;
  @media (min-width: 768px) {
    margin-left: 18%;
    margin-right: 18%;
    width: auto;
    width: 64%;
  }
  @media (min-width: 1280px) {
    width: 43%;
    margin-left: auto;
    margin-right: auto;
    margin-top: ${desktopVerticalOffset};
    margin-bottom: ${desktopVerticalOffset};
  }
`;

export const HalfContainer = styled.div`
  margin: ${mobileVerticalOffset} ${mobileSideOffset};
  flex-grow: 0;
  height: auto;

  @media (min-width: 768px) {
    margin-left: ${tabletSideOffset};
    margin-right: ${tabletSideOffset};
  }
  @media (min-width: 1280px) {
    width: 78%;
    margin-top: ${desktopVerticalOffset};
    margin-bottom: ${desktopVerticalOffset};
    margin-left: ${({ reversed }) =>
    (reversed ? 'auto' : halfContainerSideOffsetDesktop)};
    margin-right: ${({ reversed }) =>
    (reversed ? halfContainerSideOffsetDesktop : 'auto')};
  }
`;

export const HalfContainerNarrow = styled.div`
  margin: ${mobileVerticalOffset} ${mobileSideOffset};
  flex-grow: 0;
  height: auto;

  @media (min-width: 768px) {
    margin-left: ${tabletSideOffset};
    margin-right: ${tabletSideOffset};
  }
  @media (min-width: 1024px) {
    width: 78%;
    margin-top: ${desktopVerticalOffset};
    margin-bottom: ${desktopVerticalOffset};
    margin-left: ${({ reversed }) =>
    (reversed ? 'auto' : halfContainerSideOffsetDesktop)};
    margin-right: ${({ reversed }) =>
    (reversed ? halfContainerSideOffsetDesktop : 'auto')};
  }
`;

export const TextSection = styled.section`
  height: auto !important;
  @media (min-width: 768px) {
    min-height: 60vh;
  }

  @media (min-height: 1300px) {
    max-height: 1235px;
  }
`;

export const marginAlignMap = {
  left: {
    marginLeft: '7.9%',
    marginRight: 'auto',
  },
  right: {
    marginRight: '7.9%',
    marginLeft: 'auto',
  },
  center: {
    marginRight: 'auto',
    marginLeft: 'auto',
  },
};

export const Paragraph = styled.p`
  position: relative;

  margin: 0;

  white-space: pre-wrap;

  & ul {
    list-style: none;

    padding-left: 1.2rem;

    & li {
      position: relative;

      margin-bottom: 0.4rem;
    }
    & li::before {
      content: '';
      width: 10px;
      background-color: ${({ linkColor }) => linkColor};
      height: 10px;
      position: absolute;
      display: inline-block;
      top: 0.23em;
      left: -0.5em;

      @media (max-width: 1279px) {
        width: 7px;
        height: 7px;
        top: 0.4rem;
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/modules/UI/ui.js